import {Grid, Paper, Stack} from "@mui/material";
import {useTranslation} from "react-i18next";
import {useSelector} from "react-redux";
import {Controller, UseFormReturn} from "react-hook-form";
import ControlledTextFiled from "@/components/ngteco-hook-form/ControlledTextFiled";
import ControlAutoComplete from "@/components/hook-form/ControlAutoComplete";
import React, {useEffect} from "react";
import {getOrganDepts} from "@/store/slices/Department";
import {useDispatch} from "react-redux";
import NGInputLabel from "@/components/ngteco-form/NGInputLabel";
import Switch from "@mui/material/Switch";


interface FormProps {
  code: string,
  firstName: string,
  lastName: string,
  email?: string,
  departmentIdOrCode?: string,
  verify?: boolean,
  dept: {
    id: string,
    name: string
  }
}

interface EmployeeFormProps {
  employeeForm: UseFormReturn<FormProps>,
  isEditAction?: boolean,
  isViewAction?: boolean,
  isDisable?: boolean,
  paymentStatus?: boolean,
}

const EmployeeForm = (props: EmployeeFormProps) => {
  const {t} = useTranslation();
  const dispatch = useDispatch();
  const depts: { id: string, name: string }[] = useSelector((state: any) => state.dept.depts);

  useEffect(() => {
    dispatch<any>(getOrganDepts());
  }, [])

  return (
    <>
      <Paper sx={{padding: '20px 40px 40px 20px', boxShadow: 'none'}}>
        <Grid container>
          <Grid lg={12} item sx={{marginBottom: "8px"}}>
            <ControlledTextFiled
              label={t("hr.employee.Person ID")}
              name="code"
              fullWidth
              required
              disabled={props.isEditAction || props?.isViewAction}
              hookForm={props.employeeForm}
              placeholder={t("hr.employee.Person ID")}
            />
          </Grid>
        </Grid>
        <Grid container sx={{marginBottom: '8px'}}>
          <Grid lg={12} item sx={{marginBottom: "8px"}}>
            <ControlAutoComplete
              label={t("common.Department")}
              name={"dept"}
              required
              disabled={props?.isViewAction}
              form={props.employeeForm}
              options={depts}
              isOptionEqualToValue={(option: any, value: any) => {
                return option.id === value.id;
              }}
            />
          </Grid>
        </Grid>
        <Grid container>
          <Grid item lg={12} sx={{marginBottom: "8px"}}>
            <ControlledTextFiled
              hookForm={props.employeeForm}
              label={t("common.First Name")}
              name="firstName"
              fullWidth
              required
              disabled={props?.isViewAction}
              placeholder={t("common.First Name")}
            />
          </Grid>
        </Grid>
        <Grid container>
          <Grid lg={12} item sx={{marginBottom: "8px"}}>
            <ControlledTextFiled
              hookForm={props.employeeForm}
              label={t("common.Last Name")}
              name="lastName"
              fullWidth
              required
              disabled={props?.isViewAction}
              placeholder={t("common.Last Name")}
            />
          </Grid>
        </Grid>
        <Grid container>
          <Grid lg={12} item sx={{marginBottom: "8px"}}>
            <ControlledTextFiled
              hookForm={props.employeeForm}
              label={t("common.Email")}
              name="email"
              fullWidth
              // required
              disabled={props.isDisable}
              placeholder={t("common.Email")}
            />
          </Grid>
        </Grid>
        {props.paymentStatus && <Grid container>
          <Grid lg={12} item sx={{marginBottom: "8px"}}>
            <Stack direction="row" alignItems="center" justifyContent="space-between">
              <NGInputLabel label={t("common.App Access")}/>
              <Controller
                name="verify"
                control={props.employeeForm.control}
                render={({field}) => {
                  return (
                    <Switch
                      {...field}
                      checked={field.value ?? false}
                      onChange={(e) => field.onChange(e.target.checked)}
                      color="primary"
                    />
                  );
                }}
              />
            </Stack>
          </Grid>
        </Grid>}
      </Paper>
    </>
  )
}

export default EmployeeForm
